<div
    (keydown.arrowDown)="onKeyboardDown($event)"
    (click)="open()"
    class="common-forms-multi-select"
    cdkOverlayOrigin
    #origin="cdkOverlayOrigin">
    <span class="icon-open common-forms-multi-select__icon"
          [class.active]="isOpen"></span>
    <input class="inputField" type="text" autocomplete="off"
           #focusElement
           readonly="readonly" [class.open]="isOpen" [value]="selectedCommaSeparated"
           [disabled]="disabled"/>
</div>

<ng-template
    cdk-connected-overlay
    cdkConnectedOverlayHasBackdrop
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayPositions]="overlayPosition"
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    [cdkConnectedOverlayMinWidth]="280"
    (backdropClick)="close()"
    (attach)="onDropdownOpen()"
    (detach)="close()">
    <div class="common-forms-multi-select">
        <ul class="items-container"
            commonKeyboardList
            commonKeyboardListNavArrow
            commonKeyboardListNavTab
            #containerFocusElement tabindex="1"
            (commonKeyboardListThresholdTop)="onKeyboardListThresholdTop()">
            <li
                *ngFor="let item of items" class="select-items"
                commonKeyboardItem
                (keydown.escape)="onKeyboardEscape()"
                (keydown.enter)="onKeyboardEnter()"
                (keydown.space)="!(single && anySelected && !selected[item.name]) && onKeyboardSpace($event, item);"
            >
                <div>
                    <common-form-input
                        type="checkbox"
                        (isChecked)="onChecked()"
                        [(ngModel)]="selected[item.name]"
                        [label]="item.displayName"
                        [disabled]="single && anySelected && !selected[item.name]"
                    >
                    </common-form-input>
                </div>
            </li>
        </ul>
    </div>
</ng-template>
